import React from "react";
import "animate.css";
import QualityImg from "../../../assets/Quality.png"

function QualityControll() {
  const quality= [
    {
      title:"Able to check quality guides for goods in, production and goods out",
    },
    {
      title:"Detailed tracking of items from batches and able to sort out items by quality",
    },
    {
      title:"Able to quality control items from cradle to grave (goods in, during production all the way up to shipment)",
    },
    
  ]
  return (
    <div className="animate__animated animate__zoomIn">
      <div className="container  w-11/12  shadow-5xl  mx-auto  px-8 py-8  my-28">
        <div className="grid grid-cols-2 gap-20 font-Montserrat">
        <div className="md:flex md:flex-col content-start  justify-items-start">
            <div>
              <img
                src={QualityImg}
                alt="Logo"
                className="h-80  rounded-sm  "
              />
            </div>
          </div>
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <h2 className="text-blue-200 text-2xl font-bold">
              Quality Controll
            </h2>
            {quality.map((item, i) => (
             <div key={i} className="list-item pt-2 ml-8">
             
             <div>{item.title}</div>
           </div>
            ))}
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default QualityControll;
